/* eslint-disable max-len */
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageSurveyDataColumn } from '.';

export interface ManageSurveyDataTableHeadProps {
  columns: ManageSurveyDataColumn[];
};

export const ManageSurveyDataTableHead = memo((props: ManageSurveyDataTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
});

ManageSurveyDataTableHead.displayName = 'ManageSurveyDataTableHead';
